<template>
    <div wrap class="priceCompare">
        <div class="header__title header__title--center">
            <h2>{{ dataPriceCompare.title }}</h2>
            <p class="header__subline">{{ dataPriceCompare.subline }}</p>
        </div>

        <v-layout wrap>
            <v-flex xs12 sm5>
                <v-card
                    class="priceCompare__card priceCompare__card--full csCard"
                >
                    <div class="priceCompare__container">
                        <div class="priceCompare__top">
                            <SVGIcon
                                :icon-name="dataPriceCompare.careship.icon"
                                class="icon__card icon__card--large"
                            />
                            <span v-html="dataPriceCompare.careship.price" />
                        </div>

                        <h3>{{ dataPriceCompare.careship.title }}</h3>
                        <p class="header__subline">
                            {{ dataPriceCompare.careship.subline }}
                        </p>

                        <p class="priceCompare__text">
                            {{ dataPriceCompare.careship.text }}
                        </p>
                    </div>

                    <div class="priceCompare__bottom">
                        <CSButton
                            v-if="dataPriceCompare.careship.cta"
                            id="button_priceCompare_cta"
                            :text="dataPriceCompare.careship.cta.text"
                            :href="dataPriceCompare.careship.cta.link"
                            class="priceCompare__cta"
                            :on-click="
                                () =>
                                    trackEventForUserActions(
                                        'Price Comparison',
                                        dataPriceCompare.careship.cta.text,
                                        dataPriceCompare.careship.cta.link,
                                    )
                            "
                        />
                        <a
                            v-if="dataPriceCompare.careship.readmore"
                            :href="dataPriceCompare.careship.readmore.link"
                            class="priceCompare__link"
                            :onClick="
                                () =>
                                    trackEventForUserActions(
                                        'Price Comparison',
                                        dataPriceCompare.careship.readmore,
                                        dataPriceCompare.careship.readmore.link,
                                    )
                            "
                        >
                            {{ dataPriceCompare.careship.readmore.text }}
                        </a>
                    </div>
                </v-card>
            </v-flex>

            <v-flex xs12 sm1 class="priceCompare__divider">
                <span class="priceCompare__label">{{
                    dataPriceCompare.compareLabel
                }}</span>
            </v-flex>

            <v-flex xs12 sm6 class="priceCompare__cardGroup">
                <v-card
                    v-for="(item, index) in dataPriceCompare.compare"
                    :key="index"
                    class="priceCompare__card priceCompare__card--secondary"
                >
                    <div class="priceCompare__top">
                        <SVGIcon :icon-name="item.icon" class="icon__card" />
                        <span v-html="item.price" />
                    </div>

                    <h3>{{ item.title }}</h3>
                    <p class="header__subline">{{ item.subline }}</p>

                    <p class="priceCompare__text">{{ item.text }}</p>
                </v-card>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import SVGIcon from '@/components/atoms/icons/SVGIcon.vue'

import gtmTracking from '@/mixins/gtmTracking'
import {
    BASE_PRICE_PER_HOUR,
    PREFIX_BASE_PRICE_PER_HOUR,
} from '@/data/constants'
import CSButton from '~/components/atoms/button/CSButton.vue'

export default {
    name: 'PriceCompare',

    components: {
        CSButton,
        SVGIcon,
    },

    mixins: [gtmTracking],

    data: () => ({
        dataPriceCompare: {
            title: 'Eine neue Form der Unterstützung',
            subline:
                'Careship wird von unseren Kunden einzeln oder in Kombination mit herkömmlichen Pflegelösungen gebucht',
            compareLabel: 'Im Vergleich',
            careship: {
                title: 'Careship',
                subline: 'Individuelle Alltagsunterstützung',
                text:
                    'Persönliche Alltagshilfe, 1 kostenlose Kennenlernstunde, Abrechnung nach geleisteten Stunden',
                price: `${[PREFIX_BASE_PRICE_PER_HOUR, BASE_PRICE_PER_HOUR]
                    .filter(s => s !== '')
                    .join(' ')}&#8239;€ / Stunde`,
                icon: 'caregiver-love',
                cta: {
                    link: '/kunde/',
                    text: 'Alltagshilfe finden',
                },
                readmore: {
                    link: '/angebot/',
                    text: 'Was ist Alltagsunterstützung?',
                },
            },
            compare: [
                {
                    title: 'Ambulanter Pflegedienst',
                    subline: 'Med. Grundversorgung',
                    text:
                        'Fachkräftemangel, wechselnde Pfleger, intransparente Abrechnung',
                    price: '~ 560&#8239;€ / Monat',
                    icon: 'elderly-care',
                },
                {
                    title: 'Herkömmliches Pflegeheim',
                    subline: 'Ganztägige Versorgung',
                    text: 'Geringe Kapazitäten, unpersönlich, hohe Kosten',
                    price: '~ 22.608&#8239;€ / Jahr',
                    icon: 'nursing-home',
                },
            ],
        },
    }),
}
</script>

<style lang="stylus">
.priceCompare {

    &__text {
        margin: $cs-space 0 0;
    }

    &__cardGroup {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    &__card {
        margin: $cs-spaces.double 0 0;
        padding: $cs-spaces.onehalf;

        @media $display-breakpoints.sm-and-up {
            height: 100%;
            margin: $cs-spaces.onehalf 0 0;
        }

        &--secondary.v-card.v-sheet {
            background: $cs-slate-050;
            border-radius: $cs-border-radius;
            box-shadow: none;
            height: auto;
            padding: $cs-space $cs-spaces.onehalf;
        }

        &--full {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }

        &:first-child {
            margin: 0;
        }
    }

    &__bottom {
        margin-top: $cs-spaces.double;
        text-align: center;
    }

    &__link {
        color: $cs-slate-300;
        text-decoration: underline;
        transition: all ease-in-out 200ms;

        &:hover {
            color: $cs-primary;
            text-decoration: none;
        }
    }

    &__top {
        color: $cs-slate-300;
        display: flex;
        justify-content: space-between;
        text-align: right;
        margin-bottom: $cs-space;
    }

    &__cta {
        margin: 0 0 $cs-spaces.onehalf;
        width: 100%;
    }

    &__divider {
        align-items: center;
        display: flex;
        justify-content: center;
        padding: $cs-spaces.double 0;
        position: relative;
        text-align: center;

        @media $display-breakpoints.sm-and-up {
            padding: $cs-space 0;
        }

        &:after {
            background: $cs-slate-200;
            content: '';
            display: block;
            height: 1px;
            position: absolute;
            top: 50%;
            width: 100%;

            @media $display-breakpoints.sm-and-up {
                height: 100%;
                left: 50%;
                margin: 0 auto;
                top: 0;
                width: 1px;
            }
        }
    }

    &__label {
        background: $cs-white;
        color: $cs-slate-300;
        display: inline-block;
        margin: 0 auto;
        padding: 0 $cs-space;
        position: relative;
        z-index: 1;

        @media $display-breakpoints.sm-and-up {
            flex: 1 0 auto;
            transform: rotate(-90deg);
        }
    }

    .icon__card {
        height: 50px;
        width: 50px;
        margin-right: $cs-space;

        &--large {
            height: 140px;
            width: 140px;
        }
    }
}
</style>
